export const API_URL = process.env.REACT_APP_APP_URL || 'https://api.buddhawisdom.org/v1';
export const AI_URL = process.env.REACT_APP_AI_URL || 'https://ai.buddhawisdom.org';

// ── Admin: Dharmadhara system-prompt editor ─────────────────────────────────
// Auth via the logged-in user's Cognito idToken, matching the admin-call style
// used elsewhere (Authorization: Bearer <idToken>).
export const getAiConfig = async (idToken) => {
    const res = await fetch(`${API_URL}/admin/ai-config`, {
        headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
    });
    if (!res.ok) throw new Error(`Failed to load prompt (${res.status})`);
    return res.json();
};

export const updateAiConfig = async (idToken, prompt) => {
    const res = await fetch(`${API_URL}/admin/ai-config`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || `Failed to save prompt (${res.status})`);
    return data;
};

// ── Admin: user-reported issue triage ───────────────────────────────────────
// Issues that Dharmadhara files on a visitor's behalf (bugs, feature requests,
// content problems, feedback). Same idToken auth style as above.
export const getUserIssues = async (idToken, status) => {
    const params = status ? `?status=${encodeURIComponent(status)}` : '';
    const res = await fetch(`${API_URL}/admin/user-issues${params}`, {
        headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
    });
    if (!res.ok) throw new Error(`Failed to load user issues (${res.status})`);
    return res.json();
};

// ── Admin: de-identified transcript audit log ───────────────────────────────
// Raw in/out of Dharmadhara exchanges for tuning and debugging. Identities are
// hashed server-side at write time; rows expire after 90 days.
export const getAiTranscripts = async (idToken, day) => {
    const params = day ? `?day=${encodeURIComponent(day)}` : '';
    const res = await fetch(`${API_URL}/admin/ai-transcripts${params}`, {
        headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
    });
    if (!res.ok) throw new Error(`Failed to load transcripts (${res.status})`);
    return res.json();
};

export const updateUserIssue = async (idToken, { id, status, adminNote }) => {
    const res = await fetch(`${API_URL}/admin/user-issues`, {
        method: 'PUT',
        headers: { Authorization: `Bearer ${idToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, status, adminNote }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.message || `Failed to update issue (${res.status})`);
    return data;
};
